const IconBldnodes = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 285.000000 222.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <g
      transform="translate(0.000000,222.000000) scale(0.100000,-0.100000)"
      fill="#000000"
      stroke="none"
    >
      <path d="M2320 1993 c-36 -11 -62 -29 -73 -48 -8 -13 -14 -105 -17 -266 l-5 -246 -239 269 c-132 149 -251 274 -265 280 -38 14 -99 3 -127 -23 -29 -27 -41 -81 -25 -115 21 -46 712 -814 739 -821 44 -11 94 9 120 47 l24 35 -4 407 c-5 452 -4 445 -73 474 -19 8 -36 14 -37 13 -2 0 -10 -3 -18 -6z" />
      <path d="M755 1951 c-11 -5 -31 -20 -44 -35 -30 -32 -32 -94 -5 -128 11 -13 306 -346 657 -740 674 -756 666 -749 736 -733 61 13 103 83 82 138 -9 23 -1271 1450 -1314 1485 -20 17 -86 25 -112 13z" />
      <path d="M480 1252 c-58 -29 -60 -41 -53 -493 l6 -402 28 -31 c23 -26 35 -31 73 -31 36 0 51 6 73 28 l28 27 5 253 5 252 238 -268 c131 -147 247 -272 257 -277 25 -13 83 -13 113 1 47 21 71 94 46 141 -18 33 -677 771 -711 796 -37 27 -62 28 -108 4z" />
    </g>
  </svg>
);

export default IconBldnodes;
